var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-item-div"},[_c('a',{staticClass:"game-itemss aspect-square",style:(_vm.customStyle),attrs:{"href":'/game/' + _vm.game.handle}},[_c('img',{staticClass:"game-item-icon",attrs:{"src":_vm.game.thumb,"alt":_vm.game.title}})]),(_vm.showTitle)?_c('div',{staticClass:"gane-name"},[_vm._v(_vm._s(_vm.game.title))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }